export default "__VITE_ASSET__DNhNEvZV__"